/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The strings used for the Monitoring capability.
 */
export const MONITORING_CAPABILITY_STRINGS = {
  altTitle: `monitoring`,
  dialogBlurb: `is a centralized log aggregation service that collects and consolidates log data from multiple sources across the DXP.`,
  dialogBullet1: `Capture and store different log types.`,
  dialogBullet2: `Protect log data with security and compliance standards.`,
  dialogBullet3: `Quickly search and filter log history.`,
  subtitle: `View activity and performance insights.`,
  title: `Monitoring`,
};
